var _line, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgPSignalSmartControl = function SvgPSignalSmartControl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 684.2 480.2",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 684.2 480.2"
  }, props), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 372.1,
    y1: 32.1,
    x2: 363.1,
    y2: 32.1,
    fill: "none",
    stroke: "#1C9D5B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 372.6,
    y: 18.6,
    width: 27,
    height: 27,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.1,19.1v26h-26v-26L399.1,19.1 M400.1,18.1h-28v28h28V18.1L400.1,18.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M377.3,24.6c0.2,0.6,0.7,1.1,1.2,1.5s1,0.8,1.4,1.2c0.3,0.3,0.5,0.6,0.7,1c0.4,0.8,0.3,1.3-0.4,2 c-1.5-0.9-2.5-1.9-2.6-3.6c-0.2,0.4,0,1.8,0.5,2.5c0.6,1.1,1.5,1.9,2.8,2.3c0-0.4,0-0.7,0-1c0.1-1.5,0.6-2.9,1.8-3.9 c1.6-1.4,3.4-2.4,5.4-2.9c0.1,0,0.1,0,0.2,0c-0.2,0.8-0.5,1.5-0.6,2.3c-0.1,0.7-0.2,1.5-0.3,2.2c-0.4,2.6-2.4,4.7-5,4.9 c0,0,0,0-0.1,0c0.1-1.4,0.2-2.6,1-3.7c0.7-1.1,1.7-2,3-2.6c-0.5-0.2-2.5,1.1-3.4,2.2c-1.8,2.3-1.9,5.5-0.3,7.9s4.7,3.5,7.5,2.7 c2.9-0.8,5.2-3.8,4.8-7.2c0.2,1.8-0.1,3.5-1,5c-1.6,2.5-4.6,3.8-7.5,3.2s-5.1-2.9-5.6-5.9c-0.1-0.8-0.1-1.6,0-2.4 c0-0.2,0-0.3-0.1-0.4c-0.4-0.4-0.9-0.5-1.4-0.6c-1.3-0.1-2.6-1.2-2.9-2.5c-0.1-0.4-0.1-0.9,0-1.4 C376.5,26.4,376.9,25.5,377.3,24.6L377.3,24.6L377.3,24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.2,23.6c1.1,1.1,1.7,2.4,1.5,3.7s-0.5,1.8-0.6,2.1s-0.2,0.4-0.4,0.5c-0.2,0.1-0.5,0.3-0.5,0.4s-0.1,0.5-0.2,0.9 s-0.1,1-0.2,1.2s-0.3,0.3-0.5,0.2s-0.5-0.2-0.6,0s0,0.3-0.1,0.4s-0.4,0.1-0.4,0.1s0.1,0.2-0.2,0.3s-0.4,0.2-0.6,0.5 s-0.4,0.6-0.9,0.5s-0.9-0.4-1.3-0.7s-0.7-0.6-0.9-0.6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M389.9,29.8c0.1,0.1,0.2,0.2,0.3,0.4c0.1,0.1,0.2,0.2,0.4,0.3l-0.2,1c0.3,0.2,0.6,0.3,1,0.4L392,31 c0.1,0,0.3,0,0.5,0s0.3,0,0.5,0l0.6,0.9c0.3-0.1,0.7-0.2,1-0.4l-0.2-1c0.1-0.1,0.2-0.2,0.4-0.3c0.1-0.1,0.2-0.2,0.3-0.4l1,0.2 c0.2-0.3,0.3-0.6,0.4-1l-0.9-0.6c0-0.1,0-0.3,0-0.5s0-0.3,0-0.5l0.9-0.6c-0.1-0.3-0.2-0.7-0.4-1l-1,0.2c-0.1-0.1-0.2-0.2-0.3-0.4 c-0.1-0.1-0.2-0.2-0.4-0.3l0.2-1c-0.3-0.2-0.6-0.3-1-0.4l-0.6,0.9c-0.1,0-0.3,0-0.5,0s-0.3,0-0.5,0l-0.6-0.9 c-0.3,0.1-0.7,0.2-1,0.4l0.2,1",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 392.3,
    cy: 28,
    r: 1.6,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  }))))));
};
export default SvgPSignalSmartControl;